export default __webpack_public_path__ + "dcfe516.png";